var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.update)?_c('base-alert',{staticClass:"mb-4",attrs:{"type":"danger"}},[_c('i',{staticClass:"fas fa-exclamation-triangle mr-3"}),_vm._v(" "+_vm._s(_vm.$t('pwa.app-version-notice'))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }